module.exports = __webpack_public_path__ + "fonts/iconfont.345c7937.woff2";